import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { MantineProvider } from '@mantine/core';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
// import '@mantine/core/styles.css';
// import '@mantine/rte/styles.css';
import '@emotion/react';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import TestList from './pages/TestList';
import TestDetail from './pages/TestDetail';
import Results from './pages/Results';
import Profile from './pages/Profile';
import PrivateRoute from './components/common/PrivateRoute';
import About from './pages/About';
import Contact from './pages/Contact';
import Exams from './pages/Exams';
import ViewDetails from './pages/ViewDetails';
import HowToUse from './pages/HowToUse';
import PracticeTest from './pages/PracticeTest';
import ExamWriting from './pages/ExamWriting';
import ExamResult from './pages/ExamResult';
import CategoryExams from './pages/CategoryExams';

// Admin Components
import DashboardLayout from './Admin/DashboardLayout';
import Overview from './Admin/Overview';
import AddNotice from './Admin/AddNotice';
import ExamCategories from './Admin/ExamCategories';
import Messages from './Admin/Messages';
import NoticeList from './Admin/NoticeList';
import MemberShipPlan from './Admin/MemberShipPlan';
import AddTopic from './Admin/topicManage/AddTopic';
import TopicList from './Admin/topicManage/TopicList';
import EditTopic from './Admin/topicManage/EditTopic';
import AddExam from './Admin/AddExam';
import ExamList from './Admin/ExamList';
import AddStudent from './Admin/AddStudent';
import StudentList from './Admin/StudentList';
import ActivationRequest from './Admin/ActivationRequest';
import SpecialBatchRequest from './Admin/SpecialBatchRequest';
import ReportTranscriptionUserLists from './Admin/ReportTranscriptionUserLists';
import StudentResult from './Admin/StudentResult';
import MarkingRuleList from './Admin/markingRules/MarkingRuleList';
import TypingRuleForm from './Admin/markingRules/TypingRuleForm';
import MarkingRuleForm from './Admin/markingRules/MarkingRuleForm';
import TutorialManagement from './pages/admin/TutorialManagement';
import HostingerExpiryModal from './pages/HostingerExpiryModal';
import { sendApiRequest } from './utils/api';
import { useAuth } from './context/AuthContext';

function App() {

 

  return (
    <MantineProvider
      theme={{
        colorScheme: 'light',
        primaryColor: 'blue',
      }}
    >
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </MantineProvider>
  );
}

function AppContent() {
  const { login, logout } = useAuth();

   const getCurrentUser = async () => {
    const response = await sendApiRequest('api/auth/me', {}, 'GET' );
    if(!response?.data?.error){
      login(response.data);
      return
    }
    if(response.data.error){
      logout();
      return
    }
  }

  useEffect(() => {
      getCurrentUser();
  }, []);

  return (
    <Router>
      <div className="flex flex-col min-h-screen">
  {/* <HostingerExpiryModal /> */}
            <ToastContainer 
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
            <Header />
            <main className="flex-grow pt-1 bg-[#0f2a5f] font-[montserrat]">
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/exams" element={<Exams />} />
                <Route path="/how-to-use" element={<HowToUse />} />
                <Route path="/category/:categoryId" element={<CategoryExams />} />

                {/* Protected Routes */}
                <Route path="/dashboard" element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                } />
                <Route path="/tests" element={
                  <PrivateRoute>
                    <TestList />
                  </PrivateRoute>
                } />
                <Route path="/tests/:id" element={
                  <PrivateRoute>
                    <TestDetail />
                  </PrivateRoute>
                } />
                <Route path="/results" element={
                  <PrivateRoute>
                    <Results />
                  </PrivateRoute>
                } />
                <Route path="/profile" element={
                  <PrivateRoute>
                    <Profile />
                  </PrivateRoute>
                } />

                {/* Admin Routes */}
                <Route path="/admin-panel" element={
                  <PrivateRoute>
                    <div className="min-h-screen bg-gray-100">
                      <DashboardLayout />
                    </div>
                  </PrivateRoute>
                }>
                  <Route index element={<Overview />} />
                  <Route path="add-notice" element={<AddNotice />} />
                  <Route path="tutorial-management" element={<TutorialManagement />} />
                  <Route path="exam-categories" element={<ExamCategories />} />
                  <Route path="messages" element={<Messages />} />
                  <Route path="notice-list" element={<NoticeList />} />
                  <Route path="membership-plan" element={<MemberShipPlan />} />
                  <Route path="topic-add" element={<AddTopic />} />
                  <Route path="topic-list" element={<TopicList />} />
                  <Route path="topic-edit/:id" element={<EditTopic />} />
                  <Route path="exam-add" element={<AddExam />} />
                  <Route path="report-transcription-user-lists" element={<ReportTranscriptionUserLists />} />
                  <Route path="exam-list" element={<ExamList />} />
                  <Route path="student-add" element={<AddStudent />} />
                  <Route path="student-list" element={<StudentList />} />
                  <Route path="activation-requests" element={<ActivationRequest />} />
                  <Route path="special-requests" element={<SpecialBatchRequest />} />
                  <Route path="student-results" element={<StudentResult />} />
                  <Route path="marking-rules" element={<MarkingRuleList />} />
                  <Route path="marking-rules/new" element={<TypingRuleForm />} />
                  <Route path="marking-rules/:id/edit" element={<MarkingRuleForm />} />
                </Route>

                {/* Fallback Route */}
                <Route path="*" element={<Navigate to="/" replace />} />

                {/* New Route */}
                <Route path="/exams/:id" element={<ViewDetails />} />

                {/* New Route for Practice Test */}
                <Route path="/topic/:id" element={<PracticeTest />} />

                {/* Exam Writing Route */}
                <Route path="/exam-writing/:id" element={<ExamWriting />} />

                {/* New Route for Exam Result */}
                <Route path="/exam-result/:id" element={<ExamResult />} />
              </Routes>
            </main>
            <Footer />
      </div>
    </Router>
  );
}

export default App;
